import { render, staticRenderFns } from "./rightCent4.vue?vue&type=template&id=0cf9a00a&scoped=true"
import script from "./rightCent4.vue?vue&type=script&lang=js"
export * from "./rightCent4.vue?vue&type=script&lang=js"
import style0 from "./rightCent4.vue?vue&type=style&index=0&id=0cf9a00a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf9a00a",
  null
  
)

export default component.exports